module.exports = __webpack_public_path__ + "img/lv3.1bcf3086.png";